import { useImpression, useTracker } from '@archipro-website/tracker';
import type { TrackingEvent } from '@archipro-website/tracker';

/**
 * Logs `event` once, the first time `ref` has been at least half in view for a
 * second: the impression standard, for a section rather than a listed item.
 * `source` names the section, so one event can serve several of them.
 */
export const useLogSectionView = ({
    ref,
    event,
    source,
    disabled = false,
}: {
    ref: React.MutableRefObject<Element | null>;
    event: TrackingEvent;
    source: string;
    disabled?: boolean;
}) => {
    const tracker = useTracker();
    useImpression({
        ref,
        disable: disabled,
        onImpression: async (url) => {
            await tracker.log(event, { url, data: { Source: source } });
        },
    });
};
